module.exports = __webpack_public_path__ + "assets/img/surprised_boy.ea02e50e.jpg";